import { render, staticRenderFns } from "./LastMails.vue?vue&type=template&id=62c4e956&scoped=true&"
import script from "./LastMails.vue?vue&type=script&lang=ts&"
export * from "./LastMails.vue?vue&type=script&lang=ts&"
import style0 from "./LastMails.vue?vue&type=style&index=0&id=62c4e956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c4e956",
  null
  
)

export default component.exports